import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Pages/Layouts/Home";
import NotFound from "./Pages/Layouts/not-found";
import Header from "./Components/Layouts/Header";

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" Component={Home} />
        <Route path="*" Component={NotFound} />
      </Routes>
    </>
  );
}

export default App;
